import {useQuery, gql} from "@apollo/client";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getLanguagesSupported($locale: String!){
 companyDetailsCollection(limit: 1, locale: $locale){
    items{
          languageSelectionCollection {
            items {
              name
              locale
            }
          }
    }
  }
}
`;

export const useSupportedLanguages = (localeUppercase) => {
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {variables: { locale: localeUppercase}, errorPolicy: "all"});
    const supportedLanguages = data?.companyDetailsCollection?.items[0]?.languageSelectionCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useSupportedLanguages", error?.stack);
    }

    return {
        supportedLanguages,
        loading,
        error
    };
};
